import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './@modules/auth/guards/auth.guard';
import {Error403Component} from './@modules/shared/components/error-pages/error403/error403.component';
import {Error404Component} from './@modules/shared/components/error-pages/error404/error404.component';
import {Error500Component} from './@modules/shared/components/error-pages/error500/error500.component';
import {Error502Component} from './@modules/shared/components/error-pages/error502/error502.component';
import {ErrorLicenceComponent} from './@modules/shared/components/error-pages/error-licence/error-licence.component';
import {IpErrorComponent} from "./@modules/shared/components/error-pages/ip-error/ip-error.component";
import { DisconnectionComponent } from './@modules/shared/components/error-pages/disconnection/disconnection.component';
import {SsoErrorComponent} from "./@modules/shared/components/error-pages/sso-error/sso-error.component";

export const routes: Routes = [
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./@modules/main/main.module').then((m) => m.MainModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./@modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },
  {
    path: 'dataModelling',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./@modules/data-modelling/data-modelling.module').then(
        (m) => m.DataModellingModule,
      ),
  },
  {
    path: 'datasource',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./@modules/data-source/data-source.module').then(
        (m) => m.DataSourceModule,
      ),
  },
  {
    path: 'select-workspace',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./@modules/select-workspace/select-workspace.module').then(
        (m) => m.SelectWorkspaceModule,
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
    import('./@modules/auth/auth.module').then(
      (m) => m.AuthModule,
    ),
  },
  {
    path: 'share-dashboard',
    loadChildren: () =>
        import('./@modules/share-dashboard/share-dashboard.module').then(
            (m) => m.ShareDashboardModule,
        ),
  },
  {
    path:'403',
    component: Error403Component,
  },
  {
    path:'404',
    component: Error404Component,
  },
  {
    path:'500',
    component: Error500Component,
  },
  {
    path:'licence-error',
    component: ErrorLicenceComponent,
  },
  {
    path:'sso-error',
    component: SsoErrorComponent,
  },
  {
    path:'ip-error',
    component: IpErrorComponent,
  },
  {
    path:'502',
    component: Error502Component,
  },
  {
    path: 'disconnection',
    component: DisconnectionComponent,
  },

  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/404' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
